var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "insRegistrationView" },
    [
      _c(
        "div",
        { staticClass: "search_container" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "searchBox",
              attrs: { size: "mini", inline: true, model: _vm.orgData },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "赛项" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        size: "mini",
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择注册通道",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.getRegWebsiteManagement(1)
                        },
                      },
                      model: {
                        value: _vm.orgData.sysId,
                        callback: function ($$v) {
                          _vm.$set(_vm.orgData, "sysId", $$v)
                        },
                        expression: "orgData.sysId",
                      },
                    },
                    _vm._l(_vm.passagelist, function (ele) {
                      return _c("el-option", {
                        key: ele.id,
                        attrs: { label: ele.passageName, value: ele.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.getRegWebsiteManagement(1)
                },
              },
            },
            [_vm._v("查询")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "comPractice_container" },
        [
          _c("basic-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "RegWebsiteManagementTable",
            attrs: {
              isCheckbox: true,
              tableHeader: _vm.RegWebsiteManagementHeader,
              tableData: _vm.tableData,
            },
            on: { operation: _vm.operation },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.editBtn(data.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    data.row.isStatus == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openAndClosePlan(data.row, 1)
                              },
                            },
                          },
                          [_vm._v("开启")]
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openAndClosePlan(data.row, 0)
                              },
                            },
                          },
                          [_vm._v("关闭")]
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("examDialog", {
        attrs: { dialogVisible: _vm.dialogVisible, rowData: _vm.rowData },
        on: { changeDialogVisible: _vm.changeDialogVisible },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }